package com.nnod.app.nodin

private const val NODIN_PATH_PREFIX = "nodin"
private const val NODIN_DEEP_LINK_PREFIX = "nnod://nodin"

private val PATH_SAFE_CHARACTERS =
    ('A'..'Z') + ('a'..'z') + ('0'..'9') +
        listOf('-', '.', '_', '~', ':', '@', '!', '$', '&', '\'', '(', ')', '*', '+', ',', ';', '=')

fun nodInQrPayloadFromLandingUrl(landingUrl: String): String? {
    val cleaned = landingUrl.trim()
        .substringBefore('#')
        .substringBefore('?')
        .trimEnd('/')

    val schemeDelimiter = cleaned.indexOf("://")
    if (schemeDelimiter <= 0) return null

    val path = cleaned
        .substring(schemeDelimiter + 3)
        .substringAfter('/', missingDelimiterValue = "")
    val segments = path.split('/').filter { it.isNotBlank() }
    if (segments.size != 7 || segments[0] != NODIN_PATH_PREFIX) return null
    val kind = segments[1]
    if (kind != "s" && kind != "e") return null

    val decoded = segments.drop(2).map { it.decodeRouteSegmentOrNull() ?: return null }
    return buildNodInQrPayload(
        kind = kind,
        idolName = decoded[0],
        campaignId = decoded[1],
        eventName = decoded[2],
        scheduledTime = decoded[3],
        displayCode = decoded[4],
    )
}

fun buildNodInQrPayload(
    kind: String,
    idolName: String,
    campaignId: String,
    eventName: String,
    scheduledTime: String,
    displayCode: String,
): String {
    require(kind == "s" || kind == "e") { "Nod-In kind must be s or e." }
    return listOf(
        NODIN_DEEP_LINK_PREFIX,
        kind,
        idolName.encodeRouteSegment(),
        campaignId.encodeRouteSegment(),
        eventName.encodeRouteSegment(),
        scheduledTime.encodeRouteSegment(),
        displayCode.encodeRouteSegment(),
    ).joinToString("/")
}

private fun String.encodeRouteSegment(): String {
    val bytes = encodeToByteArray()
    val encoded = StringBuilder(bytes.size)
    for (byte in bytes) {
        val unsigned = byte.toInt() and 0xFF
        val char = unsigned.toChar()
        if (char in PATH_SAFE_CHARACTERS) {
            encoded.append(char)
        } else {
            encoded.append('%')
            encoded.append(HEX_DIGITS[unsigned ushr 4])
            encoded.append(HEX_DIGITS[unsigned and 0x0F])
        }
    }
    return encoded.toString()
}

private fun String.decodeRouteSegmentOrNull(): String? {
    val bytes = ArrayList<Byte>(length)
    var index = 0
    while (index < length) {
        val char = this[index]
        when (char) {
            '%' -> {
                if (index + 2 >= length) return null
                val high = hexValue(this[index + 1]) ?: return null
                val low = hexValue(this[index + 2]) ?: return null
                bytes.add(((high shl 4) or low).toByte())
                index += 3
            }
            else -> {
                bytes.addAll(char.toString().encodeToByteArray().asList())
                index += 1
            }
        }
    }
    return bytes.toByteArray().decodeToString()
}

private val HEX_DIGITS = "0123456789ABCDEF".toCharArray()

private fun hexValue(char: Char): Int? = when (char) {
    in '0'..'9' -> char.code - '0'.code
    in 'a'..'f' -> char.code - 'a'.code + 10
    in 'A'..'F' -> char.code - 'A'.code + 10
    else -> null
}
